import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentTextIcon } from '@heroicons/react/24/outline';

import { PillButton } from '../../ui/PillButton';

interface EmptyStateProps {
  heading: string;
  subtext?: string;
  showCreatePost?: boolean;
  onCreatePost?: () => void;
}

export const EmptyState: FC<EmptyStateProps> = ({ heading, subtext, showCreatePost = false, onCreatePost }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4 py-14 text-center w-[312px] mx-auto">
      <DocumentTextIcon className="size-12 text-black/30" />
      <div className="flex flex-col gap-1 items-center w-full">
        <p className="text-[15px] font-semibold leading-5 tracking-[-0.3px] text-black">{heading}</p>
        {subtext && <p className="text-[13px] leading-4 tracking-[-0.13px] text-black/50 w-[226px]">{subtext}</p>}
      </div>
      {showCreatePost && (
        <div className="flex gap-2">
          <PillButton variant="primary" onClick={() => onCreatePost?.()}>
            {t('community.feed.create_post')}
          </PillButton>
        </div>
      )}
    </div>
  );
};
